//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const checkbox = ref(1)
    const checkboxString = ref('show')

    return { checkbox, checkboxString }
  },
}
